/**
 * @generated SignedSource<<702cf9432cee36255178aa4ac3d3331f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type parentLink_lead$data = {
  readonly id: string;
  readonly " $fragmentType": "parentLink_lead";
};
export type parentLink_lead$key = {
  readonly " $data"?: parentLink_lead$data;
  readonly " $fragmentSpreads": FragmentRefs<"parentLink_lead">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "parentLink_lead",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lead",
  "abstractKey": null
};

(node as any).hash = "ee42863f6b2a79194b44808ea74595fa";

export default node;
